export class ObjectUtils {
    static removeProperty(obj, property, cloneObject) {
        let result = obj;
        if (cloneObject) {
            result = Object.assign({}, obj);
        }
        delete result[property];
        return result;
    }
}
